import React from "react";

// import { arrowBack } from "ionicons/icons";

interface Props {
	size: any;
}

export const Spacer: React.FC<Props> = ({ size }) => {
	return <div className={`spacer ${size}`} style={{ height: size + "px" }} />;
};

export default Spacer;
